import styled from '@emotion/styled';

export const FooterContainer = styled.footer`
	border-top: 1px solid ${(props) => props.theme.colors.gray100};
	background: linear-gradient(180deg, #fff 0%, ${(props) => props.theme.colors.gray} 100%);
	position: relative;

	&::before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		height: 3px;
		background: linear-gradient(90deg, ${(props) => props.theme.colors.brandNavy} 0%, ${(props) => props.theme.colors.primary400} 50%, ${(props) => props.theme.colors.primary200} 100%);
	}
`;
export const FooterWrapper = styled.footer`
	max-width: ${(props) => props.theme.scale.contentMaxWidth};
	width: 100%;
	margin: 0 auto;
	padding: 2.5rem 0;

	@media (max-width: 1225px) {
		padding: 2.4rem 2rem;
	}
`;
export const FooterContent = styled.div`
	display: flex;
	gap: 3.6rem;

	@media (max-width: 1225px) {
		flex-direction: column;
		gap: 2.4rem;
	}
`;
export const FooterContact = styled.div`
	display: flex;
	align-items: center;
	gap: 0.8rem;

	@media (max-width: 1225px) {
		flex-direction: column;
		align-items: flex-start;
		gap: 0.4rem;
	}
`;
export const FooterTitle = styled.div`
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: ${(props) => props.theme.ui.lineHeight.heading};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
`;

export const FooterInfo = styled.p`
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	font-size: ${(props) => props.theme.fontSize.sizeSm};
	line-height: ${(props) => props.theme.ui.lineHeight.body};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	white-space: pre-line;
`;
export const ImgBox = styled.div`
	width: 16rem;

	img {
		width: 100%;
	}
`;
export const FooterAbout = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	gap: 1rem;
	@media (max-width: 1225px) {
		flex-direction: column;
		align-items: flex-start;
		gap: 1rem;
	}
`;
export const ContentBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.4rem;
	@media (max-width: 1180px) {
		flex-direction: column;
		align-items: flex-start;
		gap: 0.4rem;
	}
`;
export const CopyRight = styled.div`
	font-size: ${(props) => props.theme.fontSize.sizeSm};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	color: ${(props) => props.theme.colors.grayLight};
	line-height: ${(props) => props.theme.ui.lineHeight.ui};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
`;
